import { Caption } from '@teko/ds-desktop';
import { useProductDetailState, useTenantConfig } from 'contexts';
import React, { useMemo } from 'react';
import { ProductVariantItem } from './ProductVariantItem';

export const ProductVariants: React.FC = () => {
  const { product, onSelectVariant } = useProductDetailState();
  const { productOptions, clearanceTypeDescription, sku } = product || {};
  const { fixedVariants } = useTenantConfig();

  // UX4BUYER-6250: hardcode variants for phongvu
  const variants = useMemo(() => {
    const orgVariants = productOptions?.rows;
    if (!orgVariants) return;
    if (!fixedVariants || !sku) return orgVariants;

    const fixedVariant = fixedVariants[sku];
    if (!fixedVariant) return orgVariants;

    return orgVariants.map((variant) => {
      const fixedVariantOptions = fixedVariant[variant.title];
      if (fixedVariantOptions) {
        const options = fixedVariantOptions.map((opt) => {
          const existingOption = variant.options.find(
            (option) => option.label === opt.label,
          );
          return {
            label: opt.label,
            url: opt.url,
            sku: opt.sku,
            quantity: 1,
            selected: !!existingOption,
          };
        });
        return {
          title: variant.title,
          options,
        };
      } else {
        return variant;
      }
    });
  }, [fixedVariants, productOptions?.rows, sku]);

  if (!productOptions?.rows.length) return null;

  return variants ? (
    <>
      {variants.map((variant, index) => (
        <ProductVariantItem
          key={index}
          variant={variant}
          onSelect={onSelectVariant}
        />
      ))}
      {!!clearanceTypeDescription && (
        <Caption level={1} color="textSecondary">
          {clearanceTypeDescription}
        </Caption>
      )}
    </>
  ) : (
    <React.Fragment />
  );
};
